import { Injectable } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class DeviceIdService {
  private readonly FALLBACK_DEVICE_ID = 'device-id-not-set';

  /**
   * Genera un nuovo ID dispositivo univoco.
   * @returns string L'ID del dispositivo generato
   */
  generateDeviceId(): string {
    return uuidv4();
  }
}
